import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';

import withCurrentUser from 'dpl/decorators/withCurrentUser';
import { pushParams } from 'dpl/actions/query_params';
import BreederApplication from 'dpl/join_as_breeder/components/BreederApplication';

function BreederApplicationContainer(props) {
  return <BreederApplication {...props} />;
}

export default compose(
  withCurrentUser,
  connect(null, { pushParams })
)(BreederApplicationContainer);
